module.exports = __webpack_public_path__ + "img/complete-step.0d10757d.svg";